(function() {

	// check();

	$('.owl__produtos').on('initialize.owl.carousel', function() {
		check();
	})

	$('.owl__produtos').on('initialized.owl.carousel', function() {
		check();
	})

	$('.owl__produtos').on('translated.owl.carousel', function() {
		check();
	})

	function check() {
		$('.owl__produtos .owl-item').removeClass('first second third');

		$('.owl__produtos').each(function() {
			var items = $(this).find('.owl-item.active');

			items.each(function(index) {
				if(index == 0) {
					$(this).addClass('first');
				}
				else if(index == 1) {
					$(this).addClass('second');
				}

				else if(index == 2) {
					$(this).addClass('third');
				}
			});
		});
	}
})();